// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  height: 30px;
  width: 30px;
  --padding-start: 0;
  --padding-end: 0;
  flex-shrink: 0;
}
ion-button ion-icon {
  color: var(--ion-color-medium-shade);
}

ion-list {
  padding-inline: 16px;
}
ion-list ion-item {
  --inner-padding-top: 16px;
  --inner-padding-bottom: 16px;
  --ripple-color: var(--ion-color-primary);
  --background-hover: var(--ion-color-primary);
  font-size: 18px;
  --detail-icon-color: var(--ion-color-medium-shade);
  --detail-icon-opacity: 1;
  --detail-icon-font-size: 24px;
}
ion-list ion-item ion-icon {
  margin-inline-end: 16px;
  font-size: 32px;
  color: var(--label-color, var(--ion-color-primary));
}`, "",{"version":3,"sources":["webpack://./src/components/shared-components/components/add-smart-component/add-smart-component.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AACJ;AACI;EACI,oCAAA;AACR;;AAGA;EACI,oBAAA;AAAJ;AAEI;EACI,yBAAA;EACA,4BAAA;EACA,wCAAA;EACA,4CAAA;EACA,eAAA;EACA,kDAAA;EACA,wBAAA;EACA,6BAAA;AAAR;AAEQ;EACI,uBAAA;EACA,eAAA;EACA,mDAAA;AAAZ","sourcesContent":["ion-button {\n    height: 30px;\n    width: 30px;\n    --padding-start: 0;\n    --padding-end: 0;\n    flex-shrink: 0;\n\n    ion-icon {\n        color: var(--ion-color-medium-shade);\n    }\n}\n\nion-list {\n    padding-inline: 16px;\n\n    ion-item {\n        --inner-padding-top: 16px;\n        --inner-padding-bottom: 16px;\n        --ripple-color: var(--ion-color-primary);\n        --background-hover: var(--ion-color-primary);\n        font-size: 18px;\n        --detail-icon-color: var(--ion-color-medium-shade);\n        --detail-icon-opacity: 1;\n        --detail-icon-font-size: 24px;\n\n        ion-icon {\n            margin-inline-end: 16px;\n            font-size: 32px;\n            color: var(--label-color, var(--ion-color-primary));\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
